import { SuggestedHorizontalProduct } from '@components/SuggestedHorizontalProduct/SuggestedHorizontalProduct'
import { SuggestedHorizontalProductSkeleton } from '@components/SuggestedHorizontalProduct/SuggestedHorizontalProductSkeleton'
import { Drawer } from '@velasca/ui/drawer'
import { List } from './SuggestedProductsDrawer.styles'
import type { SuggestedProductsDrawerProps } from './SuggestedProductsDrawer.types'

export const SuggestionsDrawer = ({
  title,
  products,
  isOpen,
  onClose,
  loading,
  productIDs,
}: SuggestedProductsDrawerProps) => {
  return (
    <Drawer isOpen={isOpen} close={onClose}>
      <Drawer.Header title={title} onClose={onClose} />
      <Drawer.Content>
        <List>
          {loading
            ? productIDs.map((e) => (
                <SuggestedHorizontalProductSkeleton key={e} />
              ))
            : products.map(
                ({
                  id,
                  title: suggestedProductTitle,
                  sizes,
                  customProductType,
                  isGiftCard,
                  productType,
                  variants,
                }) => (
                  <SuggestedHorizontalProduct
                    loading={loading}
                    key={id}
                    variant={variants[0]}
                    title={suggestedProductTitle}
                    productType={productType}
                    sizes={sizes}
                    customProductType={customProductType}
                    isGiftCard={isGiftCard}
                  />
                ),
              )}
        </List>
      </Drawer.Content>
    </Drawer>
  )
}
